import {
  Box,
  Flex,
  // Button,
  // FiSearch,
  // Flex,
  FormProvider,
  Table,
  TableInstance,
  TableWrapper,
  // TextField,
  useTheme,
} from '@agrotoken-tech/ui';
import { useToastsHook, useTranslation } from '@bcba/react-hooks';
// import MultiSelectDropdown from '../MultiSelectDropdown/MultiSelectDropdown';
import { Pagination } from '@bcba/frontend-utils';
import { useUserContext } from '../../../contexts/UserContext';
import { RenewAccessRequestModal } from '../RenewAccessRequestModal';
import { useSentDigitalDossierAccessRequestsTable } from './useSentDigitalDossierAccessRequestsTable';

const SentAccessRequestsTable = () => {
  const { t } = useTranslation();
  const {
    data,
    formMethods,
    isLoading,
    // onFiltersReset,
    setPage,
    tableInstance,
    // accessRequestStatusOptions,
    // selectedAccessRequestStatuses,
    // setSelectedAccessRequestStatuses,
    isRowClickableCallback,
    handleRowClick,
    highlightedStyles,
    isOpenRenewAccessRequestModal,
    onCloseRenewAccessRequestModal,
    selectedCompanyUuid,
    setSelectedCompanyUuid,
    refetch,
  } = useSentDigitalDossierAccessRequestsTable();

  const { user, refetchUser } = useUserContext();

  const availableQueries = Number(user.availableQueries) ?? 0;

  const theme = useTheme();

  const { showSuccessToast } = useToastsHook();

  const handleRenewSuccess = () => {
    onCloseRenewAccessRequestModal();
    showSuccessToast({ title: t('common.succesfullyRenewed') });
    setSelectedCompanyUuid(null);
    refetchUser();
    refetch();
  };

  return (
    <Flex
      flexDirection={'column'}
      sx={{
        // tune some styles to match figma
        '.chakra-table__container > div:first-of-type': { display: 'none' },
        table: {
          borderTop: 0,
        },
        ...highlightedStyles,
      }}
    >
      <FormProvider {...formMethods}>
        <TableWrapper
        // TODO: Uncomment search filters when implemented in backend.
        // searchComponent={
        //   <TextField
        //     name="search"
        //     leftElement={<FiSearch />}
        //     placeholder={t(
        //       'backoffice.pages.signUpRequests.table.search.placeholder',
        //     )}
        //   />
        // }
        // quickFilters={
        //   <Flex gap={4} alignItems={'center'}>
        //     <MultiSelectDropdown
        //       options={accessRequestStatusOptions}
        //       placeholder={t(
        //         'accessRequests.table.accessRequestStatusFilter.placeHolder',
        //       )}
        //       selectedOptions={selectedAccessRequestStatuses}
        //       setSelectedOptions={setSelectedAccessRequestStatuses}
        //       allText={t(
        //         'backoffice.pages.signUpRequests.table.statusFilter.allText',
        //       )}
        //     />

        //     <MultiSelectDropdown
        //       options={[]}
        //       placeholder={t(
        //         'accessRequests.table.digitalDossierStatusFilter.placeHolder',
        //       )}
        //       selectedOptions={[]}
        //       setSelectedOptions={() => console.log('Not implemented')}
        //       allText={t(
        //         'backoffice.pages.signUpRequests.table.statusFilter.allText',
        //       )}
        //     />

        //     <Button
        //       variant={'linkSecondary'}
        //       onClick={onFiltersReset}
        //       size={'xs'}
        //     >
        //       {t('common.reset')}
        //     </Button>
        //   </Flex>
        // }
        >
          <Table
            tableInstance={tableInstance as TableInstance<object>}
            isLoading={isLoading}
            emptyStateContent={{
              title: t('common.noResults'),
              description: t('common.table.emptyState'),
            }}
            isRowClickableCallback={isRowClickableCallback}
            handleRowClick={handleRowClick}
          ></Table>
        </TableWrapper>
        <Box my="3">
          <Pagination
            currentPage={data?.paginationData.currentPage!}
            totalPageCount={data?.paginationData.totalPages!}
            previousButtonLabel={t('common.previous')}
            nextButtonLabel={t('common.next')}
            onPageChange={setPage}
            theme={theme}
          />
        </Box>
      </FormProvider>

      {selectedCompanyUuid && (
        <RenewAccessRequestModal
          isOpen={isOpenRenewAccessRequestModal}
          onClose={onCloseRenewAccessRequestModal}
          companyUuid={selectedCompanyUuid}
          remainingAccessRequestsTickets={availableQueries}
          onSuccess={handleRenewSuccess}
        />
      )}
    </Flex>
  );
};
export default SentAccessRequestsTable;
